import { useState } from "react";

export default function useSessionVariables() {
  const getAllSessionVariables = () => {
    const allVariableList = [
      "access_token",
      "user_id",
      "role_id",
      "branch_id",
      "branch_name",
      "branch_info",
      "modules",
      "branch_account_name",
      "branch_account_id",
      "branch_suffix",
      "user_name",
      "financial_year",
      "financial_year_for_fetch",
    ];
    let dummyObject = {};
    let outputString = "";
    for (let i = 0; i < allVariableList.length; i++) {
      // Store access_token in sessionStorage
      if (allVariableList[i] === "access_token") {
        outputString = sessionStorage.getItem(allVariableList[i]);
      } else if (["user_id", "role_id", "modules", "user_name"].includes(allVariableList[i])) {
        outputString = localStorage.getItem(allVariableList[i]);
      } else {
        outputString = sessionStorage.getItem(allVariableList[i]);
      }
        if (outputString == null) {
        continue;
      }
      outputString = JSON.parse(outputString);
      dummyObject[allVariableList[i]] = outputString[allVariableList[i]];
    }
    return dummyObject;
  };

  const [sessionVariables, setSessionVariables] = useState(
    getAllSessionVariables()
  );

  const saveSessionVariableByField = (field, value) => {
    if (field === "access_token") {
      sessionStorage.setItem(field, JSON.stringify(value)); // Store access_token in sessionStorage
    } else {
      localStorage.setItem(field, JSON.stringify(value));
    }
    setSessionVariables({
      ...sessionVariables,
      [field]: value,
    });
  };

  const saveSessionVariableByObject = (objectToSave, fieldName) => {
    let dummyObject = {};
    for (let key in objectToSave) {
      dummyObject = { [key]: objectToSave[key] };

      if (key === "access_token") {
        sessionStorage.setItem(key, JSON.stringify(dummyObject)); // Store access_token in sessionStorage
      } else if (fieldName === "branch_info" || key === "branch_info" || key === "financial_year_for_fetch") {
        sessionStorage.setItem(key, JSON.stringify(dummyObject));
      } else {
        localStorage.setItem(key, JSON.stringify(dummyObject));
      }
    }

    setSessionVariables({
      ...sessionVariables,
      ...objectToSave,
    });
  };

  return {
    sessionVariables,
    saveSessionVariableByField,
    saveSessionVariableByObject,
  };
}